<div class="toast-container position-fixed top-0 end-0 p-3">
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast d-flex mb-4 show"
      [class.border-success]="toast.variant === 'success'"
      [class.border-danger]="toast.variant === 'error'"
      [class.border-warning]="toast.variant === 'warning'"
      [class.border-info]="toast.variant === 'info'"
      [attr.role]="roles[toast.variant]"
      [attr.aria-live]="liveness[toast.variant]"
      aria-atomic="true"
    >
      <div class="toast-body">
        <span class="toast-icon material-symbols-rounded text-white" aria-hidden="true">{{ icons[toast.variant] }}</span>
        @if (toast.title) {
          <strong class="d-block">{{ toast.title }}</strong>
        }
        {{ toast.message }}
      </div>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="dismiss(toast.id)"
      ></button>
    </div>
  }
</div>
